import DateDisplay from "components/atoms/DateDisplay/DateDisplay";
import MDButton from "components/atoms/MDButton/MDButton";
import { HeaderItems } from "components/templates/MainAppLayout/MainAppLayout";
import { routesMap } from "data/routes";
import { Appointment } from "models/AppointmentModels";
import { Patient } from "models/PatientModels";
import { RouteKeys } from "models/RouteModels";
import { MUIColors } from "models/StyleModels";
import { useNavigate } from "react-router-dom";

interface UseAppointmentLayoutProps {
  patient: Patient | null | undefined;
  appointment: Appointment | null | undefined;
  pageTitle?: string;
  disabledNav?: boolean
}

// convenience hook for generating the props required for the dashboard header in MainAppLayout
// across the exam flow

const useAppointmentLayoutProps = ({
  patient,
  appointment,
  pageTitle,
  disabledNav
}: UseAppointmentLayoutProps) => {
  const navigate = useNavigate();

  const headerItems: HeaderItems = {
    headline: patient ? `${patient.first_name} ${patient.last_name}` : '-',
    pageTitle: pageTitle,
    subItems: [
      { 'Date of Birth': patient?.date_of_birth ? <DateDisplay isoString={patient.date_of_birth} showTime={false} /> : '-' },
      { 'Appointment Date': <DateDisplay isoString={appointment?.appointment_date || ''} /> },
    ],
    secondaryContent: (
      <MDButton
        variant='outlined'
        color={MUIColors.WHITE as unknown as "inherit"} // this is some jank
        onClick={() => patient ? navigate(`${routesMap[RouteKeys.PATIENT_OVERVIEW].baseRoute}/${patient.patient_id}`) : {}}
        disabled={disabledNav === true}
      >
        Patient Overview
      </MDButton>
    ),
  };

  return {
    headerItems,
  };
};

export default useAppointmentLayoutProps;
